import React from 'react';
import PropTypes from 'prop-types';
import * as yup from 'yup';

import BotMessage from '../components/BotMessage';
import UserMessage from '../components/UserMessage';
import InputLink from '../components/InputLink';

const UserMessage1 = props => (
  <UserMessage {...props} typeInput>
    Привет, меня зовут
  </UserMessage>
);

const BotMessage2 = ({ userName, ...rest }) => (
  <BotMessage {...rest}>
    Рад знакомству, {userName}
    <br />
    Меня зовут Виталий, <nobr>какие у вас задачи?</nobr>
  </BotMessage>
);
BotMessage2.propTypes = {
  userName: PropTypes.string.isRequired,
};

const UserMessage2 = props => (
  <UserMessage {...props}>
    Я бы хотел обсудить <InputLink name="branding" />, <InputLink name="digital" />, <InputLink name="реклама" /> или{' '}
    <InputLink name="все" />
  </UserMessage>
);

const BotMessage3 = props => <BotMessage {...props}>Ок. Расскажите нам немного о вашем проекте.</BotMessage>;

const UserMessage3 = props => (
  <UserMessage {...props} typeInput>
    Немного описания
  </UserMessage>
);

const BotMessage4 = props => <BotMessage {...props}>Хорошо. Какой у вас бюджет на этот проект?</BotMessage>;

const UserMessage4 = props => (
  <UserMessage {...props}>
    Наш бюджет <InputLink name="менее 500 т.р." />, <InputLink name="менее 1 млн" />, <InputLink name="более 1 млн" />
  </UserMessage>
);

const BotMessage5 = props => (
  <BotMessage {...props}>
    Звучит неплохо.
    <br />
    Какие сроки у проекта?
  </BotMessage>
);

const UserMessage5 = props => (
  <UserMessage {...props} typeInput>
    Нужно завершить к
  </UserMessage>
);

const BotMessage6 = props => (
  <BotMessage {...props}>
    Хорошо. Пожалуйста, оставьте
    <br />
    ваш email для обратной связи.
  </BotMessage>
);

const UserMessage6 = props => (
  <UserMessage {...props} typeInput>
    Мой email
  </UserMessage>
);

const steps = [
  {
    botMessage: {
      component: null,
    },
    userMessage: {
      component: UserMessage1,
    },
    valueKey: 'f_name',
    validation: yup.string().required(),
  },
  {
    botMessage: {
      component: BotMessage2,
    },
    userMessage: {
      component: UserMessage2,
    },
    valueKey: 'f_category',
    validation: yup.string().required(),
  },
  {
    botMessage: {
      component: BotMessage3,
    },
    userMessage: {
      component: UserMessage3,
    },
    valueKey: 'f_description',
    validation: yup.string().required(),
  },
  {
    botMessage: {
      component: BotMessage4,
    },
    userMessage: {
      component: UserMessage4,
    },
    valueKey: 'f_budget',
    validation: yup.string().required(),
  },
  {
    botMessage: {
      component: BotMessage5,
    },
    userMessage: {
      component: UserMessage5,
    },
    valueKey: 'f_deadline',
    validation: yup.string().required(),
  },
  {
    botMessage: {
      component: BotMessage6,
    },
    userMessage: {
      component: UserMessage6,
    },
    valueKey: 'f_email',
    validation: yup
      .string()
      .email()
      .required(),
  },
];

export default steps;



// WEBPACK FOOTER //
// ./src/scenes/Brief/components/BriefBot/lib/steps.js